import React from 'react';
import { Card } from './ui/card';
import { Car, Gem, Cpu, Building, Radio, TrendingUp } from 'lucide-react';

export const IndustriesSection = () => {
  const industries = [
    {
      icon: Car,
      title: 'Motor Industry',
      description: 'Rent-to-own vehicle solutions and fleet management services',
    },
    {
      icon: Gem,
      title: 'Mining & Minerals',
      description: 'Responsible resource development and commodities trading',
    },
    {
      icon: Cpu,
      title: 'Technology Industry',
      description: 'Full-stack software development and digital transformation',
    },
    {
      icon: Building,
      title: 'Real Estate Industry',
      description: 'Property development and real estate investments',
    },
    {
      icon: Radio,
      title: 'Media & Advertising',
      description: 'Strategic marketing and pan-African media reach',
    },
    {
      icon: TrendingUp,
      title: 'Capital & Investment',
      description: 'Funding solutions and strategic capital partnerships',
    },
  ];

  return (
    <section id="industries" className="section-padding bg-muted/30">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Our Core{' '}
            <span className="text-primary">
              Industries
            </span>
          </h2>
          <div className="h-1 w-20 bg-primary mx-auto mb-6 rounded-full"></div>
          <p className="text-lg text-muted-foreground">
            Strategic sectors driving economic growth across the African continent
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((industry, index) => {
            const Icon = industry.icon;
            return (
              <Card
                key={index}
                className="p-6 card-hover bg-card border-border flex flex-col"
              >
                <div className="bg-primary/10 w-14 h-14 rounded-lg flex items-center justify-center mb-4">
                  <Icon className="w-7 h-7 text-primary" />
                </div>
                <h3 className="text-lg font-semibold text-foreground mb-2">
                  {industry.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {industry.description}
                </p>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;